module.exports = "/v2/pages/dashboard/dist/ec1cd57630f931143c41444f326ddc9f.svg";